module.exports = __webpack_public_path__ + "static/media/scissors.66d5d083.svg";